import { render, staticRenderFns } from "./ArtistProfile.vue?vue&type=template&id=a487041e&scoped=true"
import script from "./ArtistProfile.vue?vue&type=script&lang=js"
export * from "./ArtistProfile.vue?vue&type=script&lang=js"
import style0 from "./ArtistProfile.vue?vue&type=style&index=0&id=a487041e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a487041e",
  null
  
)

export default component.exports